import React, {useState, useContext, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../shared/context/auth-context';
import { AppointmentDailyPrintHeaders } from "../../dashboard/components/DashboardAppTableHeaders";
import { formatPhoneNumber } from "../../print/page/Print";
import { useHttpClient } from "../../shared/hooks/http-hook";
import {formatDate} from "../../print/page/Print";
import Button from '../../shared/components/formElements/Button';
import moment from 'moment';
import Table from "../../shared/components/Table/Table";
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useWindow } from '../../shared/hooks/window-hook';

function UpdateAppointments() {
  const { width } = useWindow();
  const { isLoading, sendRequest } = useHttpClient();
    const [tableState, setTableState] = useState([]);
    // const history = useHistory();
    const paramDate = useParams().date;
    const auth = useContext(AuthContext);



    const setTableData = async () => {
        const requestOptions = {
            method: 'GET',
            headers: { 
              Authorization: 'Bearer '+ auth.token
            },
            body: null
          };
  
        await fetch(process.env.REACT_APP_BACKEND_URL + `/appointments/${paramDate}`, requestOptions)
        .then( async response =>{
          const data = await response.json();
          if (response.ok) {
            const content = data.appointments.info.filter(app => app.type !== '')
              .map(app => {return ({...app,
              date: data.appointments.date.split('T')[0],
              phone : formatPhoneNumber(app.phone),
              select : app.done ? '✔️' : '' 
              })});
            setTableState(content);
        }})
    }

    useEffect(() => {
        setTableData();
    }, [])

  
  const printHandler = () => {
    window.print();
  }

 const doneClickHandler = async (id) => {
    const select = tableState.find(app => app.id === id)
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/appointments/${paramDate}/update`,
        'PATCH',
        JSON.stringify({
          select: !select.done,
          date: paramDate,
          id
        }),
        {
          'Content-Type': 'application/json',
          Authorization: 'Bearer '+ auth.token
        }
      );

      setTableData();
    } catch (err) {}

  };

  return (
    <>
    
      <div className="flex">
    {width > 800 ?  <div className=" w-25 ">
         
        </div> : ""}
        <div className=" w-25 ">
        <Button to={`/appointments/${(moment(paramDate.split('T')[0]).format('YYYY-MM-DD[T00:00:00.000Z]'))}`}>BACK</Button>
        </div>
        <div className={width > 700 ? " w-25  tc f3": " w-25  tc f5"}>
          {width > 800 ? formatDate(paramDate.split('T')[0]) : ""}
        </div>
        <div className=" w-25 ">
        </div>
        <div className=" w-25 mr4">
          <Button inverse onClick={printHandler}>                
           PRINT🖨️
          </Button>
        </div>
      </div>
         

        {isLoading && (
          <div className="center">
            <LoadingSpinner />
          </div>
        )}


          <div >
            <Table 
              headers={AppointmentDailyPrintHeaders}
              content={tableState}
              onclick={(id) => doneClickHandler(id)}
              custom
              />
          </div>        
    </>
  )
}
//history.push(`/appointments/${(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]'))}`)
export default UpdateAppointments